export const initGTMBody = () => {
    let iframe = document.createElement('iframe');
    iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-59T5678';
    iframe.height = '0';
    iframe.width = '0';
    iframe.style = 'display:none;visibility:hidden';
    let body = document.getElementsByTagName('body')[0];
    let noscript = document.createElement('noscript');
    noscript.append(iframe);
    body.insertBefore(noscript, body.firstChild);
};
